import { createFileRoute, redirect } from "@tanstack/react-router";

// Redesign consolidation (screen C): the queue is the Invoices list now. Children (new /
// batch / review / $assessmentId) stay live — they are the intake and evidence flows.
export const Route = createFileRoute("/(app)/dashboard/invoice-gate/")({
  beforeLoad: () => {
    throw redirect({ to: "/dashboard/invoices" });
  },
});
